import { groupBy } from 'lodash'

import { IconName } from '@forto-dev/phoenix-ui-core'

import { EntityType, SearchlightGroup, SearchResponse } from './types'
import { CommonTranslationKey } from '../../utils/localisation'

export const getEntityLink = (result: SearchResponse): string => {
  const { entityType, entityID, metadata } = result

  switch (entityType) {
    case 'bookings':
      return `/bookings/${entityID}`
    case 'shipments':
      return `/shipments/${entityID}`
    case 'containerNumber':
      return `/shipments/${metadata.shipmentID}`
    case 'invoices':
      return `/shipments/${metadata.shipmentID}`
    case 'activities':
    case 'customerReference':
      if (metadata.shipmentID) {
        return `/shipments/${metadata.shipmentID}`
      }
      if (metadata.bookingID) {
        return `/bookings/${metadata.bookingID}`
      }
      return '/'
    default:
      return '/'
  }
}

export const groupResults = (results: SearchResponse[]): SearchlightGroup[] => {
  const grouped = groupBy(results, (r) => r.entityType)
  return Object.entries(grouped)
    .map(([entityType, results]) =>
      isAvailableEntityType(entityType)
        ? {
            title: getEntityUIDescription(entityType).groupTitle,
            results,
          }
        : null
    )
    .filter((r) => r != null)
}

export type EntityUIDescription = {
  groupTitle: CommonTranslationKey
  icon: IconName
  prefix?: CommonTranslationKey
}

const entityUIDescription = {
  [EntityType.bookings]: {
    groupTitle: 'navigation.bookings',
    icon: 'Booking',
    prefix: undefined,
  },
  [EntityType.shipments]: {
    groupTitle: 'navigation.shipments',
    icon: 'Shipment',
    prefix: undefined,
  },
  [EntityType.customerReference]: {
    groupTitle: 'search.groups.customer_reference',
    prefix: 'search.prefixes.customer_reference',
    icon: 'Document',
  },
  [EntityType.activities]: {
    groupTitle: 'search.groups.activity',
    icon: 'Feed',
    prefix: undefined,
  },
  [EntityType.invoices]: {
    groupTitle: 'search.groups.invoice',
    icon: 'Document',
    prefix: undefined,
  },
  [EntityType.containerNumber]: {
    groupTitle: 'overview.cargoList.containerNumber',
    icon: 'Shipment',
    prefix: undefined,
  },
  // TODO: Add more
} satisfies Partial<Record<EntityType, EntityUIDescription>>

export type AvailableEntityType = keyof typeof entityUIDescription

export function getEntityUIDescription(type: AvailableEntityType): EntityUIDescription {
  return entityUIDescription[type]
}

export function isAvailableEntityType(type: string): type is AvailableEntityType {
  return type in entityUIDescription
}
